import React from 'react';
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';

import css from './jsonEditor.module.css';

export default function JsonEditorField({ values, handleChange }) {
    const containerRef = React.useRef(null);
    const jsoneditorRef = React.useRef(null);

    const editorOptions = React.useMemo(
        () => ({
            search: false,
            indentation: 2,
            statusBar: false,
            enableSort: false,
            mainMenuBar: false,
            navigationBar: false,
            showErrorTable: false,
            enableTransform: false,
            modes: ['code', 'tree'],
            onChange: () => handleChange(jsoneditorRef.current.getText())
        }),
        [handleChange, jsoneditorRef.current]
    );

    React.useEffect(() => {
        if (containerRef.current && !jsoneditorRef.current) {
            jsoneditorRef.current = new JSONEditor(containerRef.current, editorOptions);

            if (values) {
                jsoneditorRef.current.updateText(values);
            }
        }

        return () => {
            if (jsoneditorRef.current) {
                jsoneditorRef.current.destroy();
            }
        };
    }, []);

    React.useEffect(() => {
        if (jsoneditorRef.current && values !== undefined) {
            const currentText = jsoneditorRef.current.getText();
            if (currentText !== values) {
                jsoneditorRef.current.updateText(values);
            }
        }
    }, [values]);

    return <div className={css['jsoneditor-field']} ref={containerRef} />;
}
